/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { createContext, useContext, useState } from "react";

interface ModalContextType {
  showUnsubscribeModal: boolean;
  setShowUnsubscribeModal: (value: boolean) => void;
}

// Create the context with an initial value as null, and handle undefined checks.
const ModalContext = createContext<ModalContextType | undefined>(undefined);

const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);

  return (
    <ModalContext.Provider value={{ showUnsubscribeModal, setShowUnsubscribeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};

export { ModalContext, ModalProvider , useModalContext};
